import type { Row, ParseRow, BuildRow, ValidateRow } from "./types";

const parseCsv = <P, T>(
  data: string[][],
  parse: ParseRow<P>,
  validate: ValidateRow<P>,
  build: BuildRow<P, T>,
): T[] => {
  const [ columnKeys, ...dataRows ] = data;

  const rows = dataRows.map((dataRow) => {
    const row: Row = {};

    dataRow.forEach((item, index) => {
      row[columnKeys[index]] = item;
    });

    return row;
  });

  const items: T[] = [];

  rows.forEach((row, rowIndex) => {
    const parsedRow = parse(row, rowIndex);

    const isSkipped = !parsedRow;

    if (isSkipped) {
      return;
    }

    const isValid = validate(parsedRow, rowIndex);

    if (!isValid) {
      return;
    }

    const item = build(parsedRow, rowIndex);

    items.push(item);
  });

  return items;
};

export default parseCsv;
